export default function DashboardSkeleton() {
  return (
    <div className="w-full animate-pulse space-y-8">
      {/* ===================== */}
      {/* 1️⃣ TOP 4 COUNT CARDS */}
      {/* ===================== */}
      <div className="flex gap-5">
        {[1, 2, 3, 4].map((_, i) => (
          <div key={i} className="flex-1">
            {' '}
            {/* OUTER WRAPPER */}
            <div className="rounded-xl bg-gray-200 p-[2px]">
              {' '}
              {/* MIDDLE WRAPPER */}
              <div className="flex h-28 flex-col justify-between rounded-xl bg-gray-100 p-5">
                {' '}
                {/* INNER CARD */}
                <div className="h-4 w-32 rounded bg-gray-300" />
                <div className="h-8 w-20 rounded bg-gray-300" />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* ===================== */}
      {/* 2️⃣ TWO DETAIL CARDS */}
      {/* ===================== */}
      <div className="flex gap-6">
        {[1, 2].map((_, i) => (
          <div key={i} className="flex-1 space-y-5 rounded-xl border bg-white p-5">
            <div className="flex items-center justify-between">
              <div className="h-5 w-48 rounded bg-gray-200" />
              <div className="h-8 w-24 rounded-full bg-gray-200" />
            </div>

            {/* header row */}
            <div className="grid grid-cols-4 gap-4">
              {[1, 2, 3, 4].map((_, j) => (
                <div key={j} className="h-4 rounded bg-gray-200" />
              ))}
            </div>

            {/* data row */}
            <div className="grid grid-cols-4 gap-4">
              {[1, 2, 3, 4].map((_, j) => (
                <div key={j} className="h-4 rounded bg-gray-200" />
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* ===================== */}
      {/* 3️⃣ TABLE SKELETON */}
      {/* ===================== */}
      <div className="overflow-hidden rounded-xl border bg-white">
        {/* table header */}
        <div className="grid grid-cols-10 gap-4 border-b bg-gray-50 p-4">
          {[...Array(10)].map((_, i) => (
            <div key={i} className="h-4 rounded bg-gray-200" />
          ))}
        </div>

        {/* table rows */}
        {[1, 2, 3, 4, 5].map((_, row) => (
          <div key={row} className="grid grid-cols-10 gap-4 border-b p-4 last:border-b-0">
            {[...Array(10)].map((_, col) => (
              <div key={col} className="h-4 rounded bg-gray-200" />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
